import React from "react";

export default function DashboardFooter() {
  return (
    <div>
      <div class="copy_footer_wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="crm_left_footer_cont">
                <p>
                  2021 Copyright © <a> Treasure Growth Investment </a> . All
                  Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
